<div class="row" id="fr" #fr>
    <div class="col-md-12">
    </div>
  </div>
  <div class="row tabs-cont hide-nav-link" #tabsCont>
    <div class="col-md-12 h-100">
      <ngb-tabset #tabSet2="ngbTabset" [destroyOnHide]="false">
        <ngb-tab title="Pregled" id="tbList2"
         [disabled]="tabsContainerService2.IsListTabDisabled">       
          <ng-template ngbTabContent>
            <!-- {{ParametersZrc}} -->
            <yt-fw-default-list-tabs-in-update
            [ModelData]="_modelData"             
            [ParentPropertyName]="_parentPropertyName" 
            [ParentPropertyValue]="_parentPropertyValue"
            #defaultList                                
            ></yt-fw-default-list-tabs-in-update>
            <!-- <yt-fw-default-detail-list-modal [Model]="_modelData"
                    [ParentPropertyName]="'FirmaID'" >
            </yt-fw-default-detail-list-modal> -->
          </ng-template>
        </ngb-tab>
        <ngb-tab title="Izmena" id="tbUpdate2" [disabled]="tabsContainerService2.IsUpdateTabDisabled">
          <ng-template ngbTabContent>
            <div class="row">
              <div class="col-md-12">
                <yt-company-zrc-new-tab-update 
                [ModelData]="_modelData" 
                [ParentPropertyName]="_parentPropertyName" 
                [ParentPropertyValue]="_parentPropertyValue"
                #baseTabsUpdate></yt-company-zrc-new-tab-update>
              </div>
            </div>
          </ng-template>
        </ngb-tab>
      </ngb-tabset>
    </div>
  </div>